/*!

 =========================================================
 * Vue Paper Dashboard - v1.0.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";


import BootstrapVue from 'bootstrap-vue'
import numerical from '@/util/directives.js'

Vue.directive('numerical',numerical);





Vue.use(BootstrapVue);

const Bootstrap={
  
  
  computed:{
    createFormData(){
      
      return function(model,ignore){
        
        ignore=ignore?ignore:[];
        
        const data = new FormData();
        
        for (const key in model) {
          
          if(ignore.indexOf(key)!==-1){
            continue;
          }
          
          let item=model[key];
          if (item!=undefined) {
            if(typeof item=='object' && !(item instanceof File)){
              item=JSON.stringify(item);
            }
            data.append(key, item);
          }
        }
        
        return data;
      }
      
      
    },
    
    fillModel(){
      
      return function(model,data){
        
        for (const key in data) {
          if (model.hasOwnProperty(key) && data[key]) {
            
            model[key] = data[key];
          }
          
          
        }
      }
      
    },
    
    
    
    
  }
  
  
  
}

Vue.mixin(Bootstrap);



Vue.use(PaperDashboard);
const token=localStorage.getItem('token');

if(!token){
  if(router.path!='/acceso'){
    router.push('/acceso');
  }
  
}

/* eslint-disable no-new */
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
